export enum DuplicableElementIdPartEnum {
  "GR-Organisations_TEMP" = "Organization_",
  "GR-Organisations" = "Organization-Company_",
  "GR-LotResult" = "LotResult_",
  "GR-LotTender" = "Tender_",
  "GR-TenderingParty" = "Tenderer_",
  "GR-SettledContract" = "Contract_",
  "GR-Lot" = "Lot_"
}
